import {
  all,
  call,
  put,
  takeLatest,
  spawn,
  takeEvery,
} from 'redux-saga/effects';

import request from 'utils/request';
import { VENDOR_DATA_BY_ID_URL } from 'constants/url';
import { showToast } from '../Toast/actions';

import {
  disableLoaderAction,
  saveAdjustmentsAction,
  saveVendorDataByIdAction,
} from './actions';
import {
  SEARCH_ADJUSTMENTS,
  VENDOR_DATA_BY_ID,
  SEARCH_EASY_SPLIT_ADJUSTMENTS_URL,
  ADJUST_BALANCE,
  ADJUST_BALANCE_URL,
  EXPORT_TO_CSV,
  EASY_SPLIT_REFUNDS_DATA_MAPPER,
} from './constants';

export function* searchAdjustments({ data }) {
  try {
    const { options: reqOptions } = data;
    const { url, method } = SEARCH_EASY_SPLIT_ADJUSTMENTS_URL;
    const options = { method, queryString: reqOptions || {} };
    const response = yield call(request, url, options);
    yield put(saveAdjustmentsAction({ data: response.data }));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* getVendorDataById({ data: { vendorId, cb, errorCb } }) {
  try {
    const { url, method } = VENDOR_DATA_BY_ID_URL;
    const updatedUrl = url.replace('$vendor_id$', vendorId);
    const options = { method };
    const response = yield call(request, updatedUrl, options);
    if (cb) cb(response);
    else yield put(saveVendorDataByIdAction(response));
  } catch (err) {
    if (errorCb) errorCb();
    else {
      yield put(disableLoaderAction());
      yield put(showToast(err));
    }
  }
}

export function* adjustBalance({ data: { data, successCb, errorCb } }) {
  try {
    const { url, method } = ADJUST_BALANCE_URL;
    const { merchantVendorId, ...body } = data;
    const options = {
      method,
      body: JSON.stringify(body),
    };
    const updatedUrl = url.replace('$merchant_vendor_id$', merchantVendorId);
    yield call(request, updatedUrl, options);
    yield put(
      showToast({
        message: 'Vendor & merchant balances updated successfully',
        type: 'SUCCESS',
      }),
    );
    if (successCb) successCb();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    if (errorCb) errorCb();
  }
}

export function getModifiedEasySplitRefundsData(responseData) {
  const mapper = EASY_SPLIT_REFUNDS_DATA_MAPPER;
  let responseArr = [];

  for (let i = 0; i < responseData.length; i += 1) {
    const obj = responseData[i];
    const responseObj = {};
    Object.keys(obj).forEach(item => {
      if (mapper[item]) {
        responseObj[item] = obj[item];
      }
    });
    responseArr = [...responseArr, responseObj];
  }
  return responseArr;
}

export function getHeaderForEasySplitRefundsData(responseData) {
  const responseArr = Object.keys(responseData[0]);
  const mapper = EASY_SPLIT_REFUNDS_DATA_MAPPER;
  let headerArr = [];

  responseArr.forEach(item => {
    if (mapper[item]) {
      headerArr = [...headerArr, mapper[item]];
    }
  });
  return headerArr;
}

export function* exportToCSV({ data }) {
  try {
    const { cb, options: reqOptions } = data;
    const { url, method } = SEARCH_EASY_SPLIT_ADJUSTMENTS_URL;
    const options = {
      method,
      queryString: reqOptions || {},
    };
    const response = yield call(request, url, options);
    const modifiedResponseData = getModifiedEasySplitRefundsData(response.data);
    const responseArr = [
      getHeaderForEasySplitRefundsData(modifiedResponseData),
      ...modifiedResponseData,
    ];
    const filename = 'easysplit-refunds.csv';
    cb(filename, responseArr);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* searchAdjustmentsSaga() {
  yield takeLatest(SEARCH_ADJUSTMENTS, searchAdjustments);
}

export function* getVendorDataByIdSaga() {
  yield takeEvery(VENDOR_DATA_BY_ID, getVendorDataById);
}

export function* adjustBalanceSaga() {
  yield takeLatest(ADJUST_BALANCE, adjustBalance);
}

export function* exportToCSVSaga() {
  yield takeLatest(EXPORT_TO_CSV, exportToCSV);
}

// Individual exports for testing
export default function* adjustmentsSaga() {
  const sagas = [
    searchAdjustmentsSaga,
    getVendorDataByIdSaga,
    adjustBalanceSaga,
    exportToCSVSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
